import './maintenance.scss';

import Settings from "../../../../assets/images/icons/settings.png";

import { FunctionComponent } from "react";

export const MaintenanceCard: FunctionComponent = () => {

    return (
        <div className="maintenance">
            <img src={Settings} alt="manutenção" />
            <div className="maintenance-info">
                <h3>Melhorias em andamento</h3>
                <span>Estamos realizando melhorias no sistema. Algumas funções podem ficar temporariamente indisponíveis.</span>
            </div>
        </div>
    )

}
